// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"error","535":"login","826":"class.index"}[chunkId] || chunkId) + "." + {"41":"9e3903a9","183":"cd0e0e72","535":"68cef515","826":"42ee4e0c","962":"22a6a787"}[chunkId] + ".js";
};